import { useState } from 'react';
import { faqList } from '@/mocks/faq';

export default function FAQAccordion() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqList.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
            <span className="text-accent-400 text-sm font-medium uppercase tracking-wider">常见问题</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            你关心的<span className="text-primary-400">问题</span>
          </h2>
          <p className="text-foreground-400 text-sm mt-2">关于91制片厂的常见疑问，这里都有答案</p>
        </div>

        <div className="space-y-3">
          {faqList.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-100 border border-background-200/30 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-50 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 text-lg ${
                    openId === faq.id ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-400 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}